import { render, staticRenderFns } from "./TrainWorkers.vue?vue&type=template&id=22ed1508&scoped=true"
import script from "./TrainWorkers.vue?vue&type=script&lang=js"
export * from "./TrainWorkers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed1508",
  null
  
)

export default component.exports